<template>
    <b-navbar toggleable="md" type="dark" variant="dark">
        <img src="../assets/Rock_Records logo.png" img-left class="float-left" alt="Daughtry">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-container>
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item class="nav-link" to="/HomeRock"><strong>ROCK RECORDS</strong></b-nav-item>
              <b-nav-item class="nav-link" to="/ArtistasRock"><strong>ARTISTAS</strong></b-nav-item>
              <b-nav-item class="nav-link" to="/FestivalsRock"><strong>FESTIVALES</strong></b-nav-item>
              <b-nav-item class="nav-link" to="/NovetatsRock"><strong>NOVEDADES</strong></b-nav-item>
              <b-nav-item class="nav-link" to="/QUiSomRock"><strong>¿QUIENES SOMOS?</strong></b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
    </b-navbar>
  </template>
  
  
  <script>
  export default {
  
  
  }
  </script>
  
  
  <style scoped>
  
  .router-link-exact-active, .router-link-active {
    background-color: rgb(0, 0, 0);
  }
  </style>